import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'
import { lineItemInstallmentEdited } from '@fixtures/apis/bill/line-item/installment-edited'
import { lineItemInstallmentReimbursed } from '@fixtures/apis/bill/line-item/installment-reimbursed'

import { lineItemDebitChargebacktMock } from '@fixtures/apis/bill/line-item/debt-chargeback'
import { lineItemDebitPurchaseMock } from '@fixtures/apis/bill/line-item/debt-purchase'
import { lineItemDebitFineMock } from '@fixtures/apis/bill/line-item/debt-fine'

import { lineItemCashinCreditMock } from '@fixtures/apis/bill/line-item/cash-in-credit'
import { lineItemCashinFinancingMock } from '@fixtures/apis/bill/line-item/cash-in-financing'
import { lineItemCashinPaymentMock } from '@fixtures/apis/bill/line-item/cash-in-payment'
import { lineItemCashinReceivableMock } from '@fixtures/apis/bill/line-item/cash-in-receivable'
import { BillLIneItemGroup } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

const allLineItems: BillLIneItemGroup[] = [
  {
    line_items: [
      lineItemInstallment.build(),
      lineItemCashinPaymentMock.build(),
    ],
    is_paid: true,
  },
  {
    line_items: [
      lineItemInstallmentEdited.build(),
      lineItemCashinPaymentMock.build(),
      lineItemCashinCreditMock.build(),
    ],
    is_paid: true,
  },
  {
    line_items: [
      lineItemDebitPurchaseMock.build(),
      lineItemDebitFineMock.build(),
    ],
    is_paid: false,
  },
  {
    line_items: [
      lineItemDebitPurchaseMock.build(),
      lineItemDebitFineMock.build(),
      lineItemCashinPaymentMock.build(),
    ],
    is_paid: true,
  },
  {
    line_items: [
      lineItemInstallment.build(),
      lineItemInstallment.build(),
      lineItemDebitPurchaseMock.build(),
      lineItemDebitFineMock.build(),
      lineItemCashinPaymentMock.build(),
    ],
    is_paid: true,
  },
  {
    line_items: [
      lineItemCashinFinancingMock.build(),
      lineItemCashinPaymentMock.build(),
    ],
    is_paid: true,
  },
  {
    line_items: [
      lineItemCashinReceivableMock.build(),
      lineItemDebitChargebacktMock.build(),
    ],
    is_paid: true,
  },
  {
    line_items: [
      lineItemInstallment.build(),
      lineItemInstallmentReimbursed.build(),
      lineItemCashinCreditMock.build(),
    ],
    is_paid: true,
  },
]

export const allLineItemsGroupMock = new MockFactory<BillLIneItemGroup[]>(
  allLineItems
)
